"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOptions = void 0;
const class_validator_1 = require("class-validator");
exports.defaultOptions = {
    additionalConverters: {},
    classValidatorMetadataStorage: class_validator_1.getMetadataStorage(),
    refPointerPrefix: '#/definitions/',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3B0aW9ucy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9vcHRpb25zLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUNBLHFEQUl3QjtBQWlDWCxRQUFBLGNBQWMsR0FBYTtJQUN0QyxvQkFBb0IsRUFBRSxFQUFFO0lBQ3hCLDZCQUE2QixFQUFFLG9DQUFrQixFQUFFO0lBQ25ELGdCQUFnQixFQUFFLGdCQUFnQjtDQUNuQyxDQUFBIn0=